"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tick = exports.Track = exports.Handle = void 0;
var React = __importStar(require("react"));
var Handle = function (_a) {
    var _b = _a.domain, min = _b[0], max = _b[1], _c = _a.handle, id = _c.id, value = _c.value, percent = _c.percent, getHandleProps = _a.getHandleProps;
    return (React.createElement("div", __assign({ role: "slider", "aria-valuemin": min, "aria-valuemax": max, "aria-valuenow": value, style: {
            left: percent + "%",
            position: 'absolute',
            marginLeft: '-11px',
            marginTop: '-6px',
            zIndex: 2,
            width: 24,
            height: 24,
            cursor: 'pointer',
            borderRadius: '50%',
            boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.2)',
            backgroundColor: '#fff',
        } }, getHandleProps(id))));
};
exports.Handle = Handle;
var Track = function (_a) {
    var source = _a.source, target = _a.target, getTrackProps = _a.getTrackProps;
    return (React.createElement("div", __assign({ style: {
            position: 'absolute',
            height: 14,
            zIndex: 1,
            backgroundColor: '#008272',
            borderRadius: 7,
            cursor: 'pointer',
            left: source.percent + "%",
            width: target.percent - source.percent + "%",
        } }, getTrackProps())));
};
exports.Track = Track;
var Tick = function (_a) {
    var tick = _a.tick, count = _a.count;
    return (React.createElement("div", null,
        React.createElement("div", { style: {
                position: 'absolute',
                marginTop: 14,
                width: 1,
                height: 5,
                backgroundColor: 'rgb(200,200,200)',
                left: tick.percent + "%",
            } }),
        React.createElement("div", { style: {
                position: 'absolute',
                marginTop: 22,
                fontSize: 10,
                textAlign: 'center',
                marginLeft: -(100 / count) / 2 + "%",
                width: 100 / count + "%",
                left: tick.percent + "%",
            } }, tick.value)));
};
exports.Tick = Tick;
